import React, { useState, useEffect } from "react";
import StepOne from '../AutoRegisterFormComponents/StepOne';
import { getRightPanelStyles } from '../../styles/AutoRegisterFormStyles';

const RightPanel = ({ 
  step, 
  formData, 
  setFormData, 
  isFormValid, 
  handleSubmit, 
  currentStep,
  onBack,
  isExpanded = false,
  content,
  fullContent,
  onStepValidationChange,
  hideRegistrationMethodStep = false,
  isMobileView = false
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [buttonBlocked, setButtonBlocked] = useState(false);
  const styles = getRightPanelStyles(isExpanded, isMobileView, step);

  // Reset hover state when step changes
  useEffect(() => {
    setIsHovered(false);
  }, [step]);

  // Update button blocked state whenever formData changes or current step changes
  useEffect(() => {
    setButtonBlocked(false);
  }, [formData, currentStep]);
  
  const getStepContent = () => {
    if (!content || !fullContent) {
      return {
        title: "Załóż konto",
        component: <StepOne
          formData={formData}
          setFormData={setFormData}
          isFormValid={isFormValid}
          content={null}
          onValidationChange={(isValid) => onStepValidationChange && onStepValidationChange(1, isValid)}
        />
      };
    }

    return {
      title: content.step1.title,
      component: <StepOne
        formData={formData}
        setFormData={setFormData}
        isFormValid={isFormValid}
        content={fullContent.stepOne}
        onValidationChange={(isValid) => onStepValidationChange && onStepValidationChange(1, isValid)}
        isMobileView={isMobileView}
      />
    };
  };

  const stepContent = getStepContent();

  const isButtonDisabled = () => {
    const basicDisabled = !isFormValid();
    return basicDisabled || buttonBlocked;
  }

  const isLastStep = () => {
    return currentStep >= 1;
  }

  return (
    <div style={styles.rightPanel}>
      <div style={styles.headerSection}>
        <div style={styles.titleContainer}>
          {step > 1 && (
            <button 
              onClick={onBack} 
              style={{
                ...styles.backButton,
                backgroundColor: isHovered ? "#f2f5fc" : "#fff"
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              aria-label={fullContent.rightPanel.backButton.ariaLabel}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" fill="#A6ADBD"/>
              </svg>
            </button>
          )}
          <h2 style={styles.rightTitle}>{stepContent.title}</h2>
        </div>
        <div style={styles.customBlueLine}></div>
      </div>
        <div style={styles.formContainer}>
          {stepContent.component}
        <div style={styles.bottomSection}>
          <button 
            type="submit" 
            style={{
              ...styles.button,
              backgroundColor: isButtonDisabled() ? "#9ABCF4" : "#407EF9",
              cursor: isButtonDisabled() ? "not-allowed" : "pointer"
            }} 
            disabled={!isFormValid() || isButtonDisabled()} 
            onClick={handleSubmit}
          >
            {isLastStep() ? fullContent.rightPanel.buttons.finish : fullContent.rightPanel.buttons.next}
          </button>
          {step === 1 && fullContent?.rightPanel?.existingAccount && (
            <div style={styles.existingAccount}>
              {fullContent.rightPanel.existingAccount.text}{' '}
              <a
                href={fullContent.rightPanel.existingAccount.url}
                style={styles.existingAccountLink}
              >
                {fullContent.rightPanel.existingAccount.linkText}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RightPanel; 
